module.exports = __webpack_public_path__ + "img/warn.36678d01.png";